/**
 * Every build names its chunks anew, and an update removes the old ones: a tab opened before it
 * fails to load the next page it opens ("error loading dynamically imported module"). Vite reports
 * that as vite:preloadError; reload once, which fetches the new index.html (served no-cache) and
 * with it the new chunks. Not again within a minute: a chunk missing from the new version too, or
 * no session storage to remember the reload in, shows the error page instead of reloading forever.
 */
const KEY = 'velanox.reloadedForStaleChunk'

export function reloadOnStaleChunk(): void {
  window.addEventListener('vite:preloadError', () => {
    try {
      if (Date.now() - Number(sessionStorage.getItem(KEY) ?? 0) < 60_000) return
      sessionStorage.setItem(KEY, String(Date.now()))
    } catch { return }
    window.location.reload()
  })
}
